// ============================================
// Home Module - Event Handlers (ES6)
// onclick 핸들러를 이벤트 위임으로 처리
// ============================================

import {
  switchHomeCategory,
  loadHomeContent,
  renderHomeCard,
  changeRankingPeriod
} from './content.js';

import { showLoginModal } from '../auth/index.js';

import {
  openSearchModal,
  closeSearchModal,
  handleSearch
} from './search.js';

import {
  showContentDetail,
  toggleContentLike,
  closeContentDetailModal,
  showDetailMenu,
  closeDetailMenu,
  editMyCreation,
  shareContent,
  reportContent,
  blockCreator,
  startNewChat,
  continueRoom
} from './detail.js';

// ============================================
// 이벤트 리스너 초기화
// ============================================

export function initHomeEvents() {
  // Home 탭 버튼 (카테고리 전환)
  document.querySelectorAll('.home-tab-btn[data-category]').forEach(btn => {
    btn.addEventListener('click', () => {
      const category = btn.dataset.category;
      if (category) switchHomeCategory(category);
    });
  });

  // 랭킹 기간 드롭다운 (초기 숨김 + 이벤트)
  const rankingPeriodSelect = document.getElementById('rankingPeriodSelect');
  if (rankingPeriodSelect) {
    rankingPeriodSelect.style.display = 'none';  // 초기에 숨김 (캐릭터 탭이 기본)
    rankingPeriodSelect.addEventListener('change', (e) => {
      changeRankingPeriod(e.target.value);
    });
  }

  // 검색 버튼
  const searchBtn = document.querySelector('.home-search-btn');
  if (searchBtn) {
    searchBtn.addEventListener('click', openSearchModal);
  }

  // 검색 모달 닫기 버튼
  const searchCloseBtn = document.querySelector('#searchModal .search-close-btn');
  if (searchCloseBtn) {
    searchCloseBtn.addEventListener('click', closeSearchModal);
  }

  // 검색 입력 필드
  const searchInput = document.getElementById('searchInput');
  if (searchInput) {
    searchInput.addEventListener('input', handleSearch);
  }

  // 콘텐츠 상세 모달 닫기 버튼
  const detailBackBtn = document.querySelector('#contentDetailModal .detail-back-btn');
  if (detailBackBtn) {
    detailBackBtn.addEventListener('click', closeContentDetailModal);
  }

  // 콘텐츠 상세 메뉴 버튼
  const detailMenuBtn = document.querySelector('#contentDetailModal .detail-menu-btn');
  if (detailMenuBtn) {
    detailMenuBtn.addEventListener('click', showDetailMenu);
  }

  // 좋아요 버튼
  const likeBtn = document.getElementById('detailLikeBtn');
  if (likeBtn) {
    likeBtn.addEventListener('click', toggleContentLike);
  }

  // 상세 메뉴 모달 - 백드롭 클릭 및 메뉴 항목
  const detailMenuModal = document.getElementById('detailMenuModal');
  if (detailMenuModal) {
    detailMenuModal.addEventListener('click', (e) => {
      // 백드롭 클릭 시 닫기
      if (e.target === detailMenuModal) {
        closeDetailMenu();
        return;
      }

      // 메뉴 항목 클릭 처리 (data-action 사용)
      const menuItem = e.target.closest('[data-action]');
      if (!menuItem) return;

      const action = menuItem.dataset.action;

      switch (action) {
        case 'cancel':
          closeDetailMenu();
          break;
        case 'edit':
          editMyCreation();
          break;
        case 'share':
          shareContent();
          break;
        case 'report':
          reportContent();
          break;
        case 'block':
          blockCreator();
          break;
      }
    });
  }

  // 홈 그리드 이벤트 위임 (동적 생성되는 카드 클릭)
  const homeGrid = document.getElementById('homeContentGrid');
  if (homeGrid) {
    homeGrid.addEventListener('click', (e) => {
      // 카드 래퍼 클릭 시 상세 모달 열기
      const cardWrapper = e.target.closest('.home-card-wrapper');
      if (cardWrapper) {
        const contentId = cardWrapper.dataset.contentId;
        if (contentId) {
          showContentDetail(contentId);
        }
      }
    });
  }

  // 검색 결과 이벤트 위임
  const searchResults = document.getElementById('searchResults');
  if (searchResults) {
    searchResults.addEventListener('click', (e) => {
      // 카드 클릭
      const cardWrapper = e.target.closest('.home-card-wrapper');
      if (cardWrapper) {
        const contentId = cardWrapper.dataset.contentId;
        if (contentId) {
          showContentDetail(contentId);
        }
      }
    });
  }

  // 액션 버튼 이벤트 위임 (새로하기, 이어하기, 채팅하기)
  const mainActions = document.getElementById('detailMainActions');
  if (mainActions) {
    mainActions.addEventListener('click', (e) => {
      const btn = e.target.closest('.detail-action-btn');
      if (!btn) return;

      const action = btn.dataset.action;
      const id = btn.dataset.id;

      if (action === 'startNew' && id) {
        startNewChat(id);
      } else if (action === 'continueRoom') {
        const roomId = btn.dataset.roomId;
        const sessionCount = parseInt(btn.dataset.sessionCount, 10) || 1;
        const lastSessionId = btn.dataset.lastSessionId;
        continueRoom(roomId, sessionCount, lastSessionId);
      } else if (action === 'login') {
        showLoginModal();
      }
    });
  }

  console.log('[HomeEvents] 이벤트 리스너 초기화 완료');
}

// ============================================
// 모듈 초기화
// ============================================

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHomeEvents);
} else {
  initHomeEvents();
}

export default { initHomeEvents };
